// extracted by mini-css-extract-plugin
export default {"card":"menuDisplay_card__4VwNZ","separator":"menuDisplay_separator__ArZNF","menuName":"menuDisplay_menuName__oxuze","button":"menuDisplay_button__dCYcT"};